import { render, staticRenderFns } from "./PeViews.vue?vue&type=template&id=29507962&"
import script from "./PeViews.vue?vue&type=script&lang=js&"
export * from "./PeViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports